import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 're-import-confirmation-dialog',
    templateUrl: './import-confirmation-dialog.component.html',
    styleUrls: ['./import-confirmation-dialog.component.scss'],
    standalone: false
})
export class ImportConfirmationDialogComponent {
  @ViewChild("form")
  form: NgForm;

  numberOfUsers = 0;

  domain: string;
  crmID: string;

  lowerCase: boolean;
  upperCase: boolean;
  numberCase: boolean;
  minLengthCase: boolean;
  specialCharacterCase: boolean;

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void { }

  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }
}
